const constants = require('@/util/constants')
require('./config')

/**
 * 分配客服之前，验证用户名是否已经被占用
 * @param {*} username 用户名
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function agentnameValidate (username, successcb, failedcb) {
  axios.get('/api/user/validate', {
    params: {
      'username': username,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建客服账号
 * @param {*} username 用户名
 * @param {*} password 密码
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createAgent (username, password, email, avatar, realName, nickname, maxThreadCount,
  workGroups, role, enabled, successcb, failedcb) {
//
  axios.post('/api/user/create', {
    username,
    password,
    email,
    avatar,
    realName,
    nickname,
    maxThreadCount,
    workGroups,
    role,
    enabled
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新客服账号
 * @param {*} username 用户名
 * @param {*} password 密码
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateAgent (id, username, password, email, avatar, realName, nickname, maxThreadCount,
  workGroups, role, enabled, successcb, failedcb) {
//
  axios.post('/api/user/update', {
    id,
    username,
    password,
    email,
    avatar,
    realName,
    nickname,
    maxThreadCount,
    workGroups,
    role,
    enabled
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除客服账号
 * @param {*} id id
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteAgent (id, successcb, failedcb) {
  axios.post('/api/user/delete', {
    id
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
